module.exports = __webpack_public_path__ + "static/media/IMG_0322.3d6387fd.JPG";